module.exports = __webpack_public_path__ + "static/media/support-station-main-img.2385b82a.jpg";